import { typedHttp } from '../http';
import { type RequestBody } from '../http/type-helpers';

import {
  APPLE_CREDENTIALS_ENDPOINT,
  APPLE_LOGIN_ENDPOINT,
  LOGIN,
} from '@/constants/endpoints';

export function login(credentials: RequestBody<typeof LOGIN>) {
  return typedHttp.post(LOGIN, credentials, {
    withDeviceId: true,
  });
}

export function loginWithApple(
  appleCredentials: RequestBody<typeof APPLE_LOGIN_ENDPOINT>
) {
  const { apple_user_id, apple_access_token } = appleCredentials;
  return typedHttp.post(
    APPLE_LOGIN_ENDPOINT,
    { apple_user_id, apple_access_token },
    {
      withDeviceId: true,
    }
  );
}

export function fetchAppleCredentials(appleCredentialRequest: {
  code: string;
  redirect_uri: string;
}) {
  return typedHttp.post(APPLE_CREDENTIALS_ENDPOINT, appleCredentialRequest);
}
